import { CheckboxChangeEvent, FormInstance } from 'antd';
import { ColumnsType, TableProps } from 'antd/es/table';
import {
  Product,
  Staff,
  InventoryDocument,
  InventoryDocumentType,
  PaymentType,
  Supplier,
  InventoryDocumentItem,
  Profile,
  Unit as UnitModel,
  Attribute as AttributeModel,
  Brand,
  ProductVersion,
  Debt,
} from 'models';
import { Dayjs } from 'dayjs';
import React, { JSX, ReactNode } from 'react';
import Category, { CategoryFormValues } from 'models/Category';
import { Status as StatusType } from 'models';
import { Transaction } from 'models/Transaction';
import { TransactionMethod } from 'models/TransactionMethod';
import { CustomerCreate } from 'models/Customer';
import { SaleOrderItem } from 'models/SaleOrder';
import { TransactionMethodCode } from 'models/TransactionMethod';
import { SupplierFormValues } from 'models/Supplier';
export interface AuthenticationResult {
  profile?: Profile;
  staff?: Staff;
  accessToken: string;
  refreshToken: string;
  LoginDate?: string;
  ExpiryDate?: string;
  remember?: boolean;
}

export type Loading = 'idle' | 'pending' | 'succeeded' | 'failed';
export type NotificationType = 'success' | 'error' | 'info' | 'warning';
export type QueryParams = {
  search?: string;
  page?: string | number;
  limit?: string | number | 'unlimited';
  include?: string;
  includeRef?: string;
  orderBy?: string;
  subQuery?: boolean;
  filter?: string;
  sort?: string;
  searchKey?: string;
  searchValue?: string;
  checkedList?: string;
} & { [key: string]: string | number };

// Define proper types for selectors and action
export type Action<P> = (params: P) => { type: string; payload?: unknown };
export type Selector<T> = (state: unknown) => T;

export enum Gender {
  MALE = 'male',
  FEMALE = 'female',
  OTHER = 'other',
}

export interface PaginationParams {
  page?: number;
  pageSize?: number;
  sort?: string;
  order?: 'asc' | 'desc';
}

export interface PaginatedResponse<T> {
  data: T[];
  meta: {
    currentPage: number;
    totalPages: number;
    totalItems: number;
    itemsPerPage: number;
  };
}
export interface LoginFormValues {
  email: string;
  password: string;
  remember?: boolean;
  confirmPassword?: string;
}

export interface FormProps<T> {
  initialValues: T;
  onSubmit: (values: T) => void;
}

export interface AppRouteType {
  name: string;
  path: string;
  auth?: boolean;
  roles?: number;
  isPublic?: boolean;
  noLayout?: boolean;
  noWrapper?: boolean;
  permissions?: Permissions[];
  element: JSX.Element;
  setting?: boolean;
}

export interface SuccessResponse {
  success: boolean;
  data: { [key: string]: unknown };
}

export interface MenuItemType {
  key: string;
  label: string;
  path?: string;
  icon?: ReactNode;
  contentHeader?: string;
  children?: MenuItemType[];
  subMenuDisplay?: boolean;
  isHide?: boolean;
  hasPage?: boolean;
  permission?: string;
  permissions?: string[];
}
export interface OverviewMenuItem {
  id: string;
  title: string;
  description: string;
  previewUrl: string;
  navigateTo: string;
  permission: string;
}
export interface ResponseForgot {
  statusCode: number;
  message: string;
  success: boolean;
}
export interface ResponseReset {
  email: string;
  success: boolean;
  expiredAt?: string;
}
export interface ItemBreadcrumb {
  title: string;
  path?: string;
}
export interface ListBreadcrumb {
  items: ItemBreadcrumb[];
}
export interface Attribute {
  attributeId: string | number;
  attribute?: AttributeModel;
  title?: string;
  costPrice?: number;
  salePrice: number;
  convertValue?: number;
  surcharge?: number;
  note?: string;
  order: number;
}
export interface Unit {
  checked?: boolean;
  label?: string;
  name?: string;
  unitId?: string | number | null;
  unit?: UnitModel;
  title?: string;
  costPrice: number;
  salePrice: number;
  convertValue: number;
  surcharge?: number;
  note?: string;
  order: number;
  isNew?: boolean;
}
export interface AttributeManagerOptionProps {
  name: string;
  value: string | number;
  surcharge?: number;
  note?: string;
  attributeId?: string | number;
}
export interface AttributeManagerProps {
  type?: string;
  treeList: Attribute[];
  attributes?: AttributeManagerOptionProps[];
  onTreeListChange: (items: Attribute[]) => void;
  placeholderTitle?: string;
  placeholderSurcharge?: string;
  onDelete?: () => void;
  placeholderNote?: string;
  buttonName?: string;
  isEdits?: boolean;
}
export interface TreeComponentProps {
  children: React.ReactNode;
  className?: string;
  variantStatus?: 'default' | 'bordered' | 'shadow';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  radius?: 'sm' | 'md' | 'lg';
}
export interface PropsPassRequirement {
  email: string;
  isPasswordDuplicate: boolean;
  form: FormInstance;
}
export interface ManageAttributeProps {
  isEdits?: boolean;
  title: string;
  surcharge?: number;
  // inputPrice: number;
  // sellPrice: number;
  type: string;
  // conversionValue: number;
  note?: string;
  order: number;
  onDeleteTree?: (order: number) => void;
  className?: string;
  onSaveChange?: (value: { title: string; surcharge: number; note: string; order: number }) => void;
  attributes?: AttributeManagerOptionProps[];
}
export interface FieldProduct {
  label: string;
  name: string;
  placeholder: string;
  type: 'text' | 'select' | 'money';
  options?: { label: string; value: string }[];
  defaultValue?: string;
  addonAfterNode?: React.ReactNode;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  loading?: boolean;
}

export interface FormInputProductrops {
  form: FormInstance;
  fields: FieldProduct[];
  isDisabled?: boolean;
}
export interface CollapseCommonProps {
  title?: string | ReactNode;
  defaultActive?: boolean;
  positionIcon?: 'start' | 'end';
  collapseKey: string | number;
  children: React.ReactNode;
  className?: string;
  size?: 'md' | 'xl' | 'sm';
  hideExpandIcon?: boolean;
  disableCollapse?: boolean;
}
export interface ListItemKPI {
  icon?: ReactNode;
  value?: string;
  description?: ReactNode | string;
  iconDescription?: ReactNode | string;
  onClick?: () => void;
}

export interface BaseRecord<T> {
  [key: string | number]: string | number | Date | boolean | null | undefined | React.ReactNode | T[] | T;
}
export enum Status {
  ACTIVE = 'Đang hoạt động',
  DRAFT = 'Bản nháp',
  INACTIVEVERSION = 'Không kích hoạt',
  INACTIVE = 'Ngừng kinh doanh',
  PAID = 'Đã thanh toán',
  DRAFT_PAYMENT = 'Đơn nháp',
  PAYMENT_DEFERRENCE = 'Thanh toán sau',
  WAIT_PAYMENT = 'Đợi thanh toán',
  WAIT_CONFIRM = 'Đợi xác nhận đơn',
}
export enum StatusOrderSupplierCode {
  PAID = 'Paid',
  PAYMENT_DEFERRENCE = 'Payment deferred',
  WAIT_PAYMENT = 'Waiting for payment',
  WAIT_CONFIRM = 'Waiting for Confirmation',
  DRAFT_PAYMENT = 'Draft',
}
export const StatusOrderSupplier: Record<StatusOrderSupplierCode, string> = {
  [StatusOrderSupplierCode.PAID]: 'Đã thanh toán',
  [StatusOrderSupplierCode.PAYMENT_DEFERRENCE]: 'Thanh toán sau',
  [StatusOrderSupplierCode.WAIT_PAYMENT]: 'Đợi thanh toán',
  [StatusOrderSupplierCode.WAIT_CONFIRM]: 'Đợi xác nhận đơn ',
  [StatusOrderSupplierCode.DRAFT_PAYMENT]: 'Đơn nháp',
};
export interface ProductColumn extends BaseRecord<unknown> {
  key: string;
  ['product.code']: string;
  name: string;
  version: string | number;
  ['category.name']: string;
  ['brand.name']: string;
  ['product.quantity']: number;
  stock: number;
  ['status.name']: Status | string;
  salePrice: string | number;
  costPrice: string | number;
  ['product.barcode']: string;
  ['baseUnit.name']?: string;
  productId: string;
}
export interface OrderSupplierColumn extends BaseRecord<unknown> {
  key: string;
  code: string;
  createdAt: string;
  ['supplier.baseUser.name']: string;
  total: number;

  paidMoney: number;
  unpaidMoney: number;
  ['status.name']?: (typeof StatusOrderSupplier)[keyof typeof StatusOrderSupplier] | string;
}

export interface UnitRecord extends BaseRecord<unknown> {
  key: string;
  code: string;
  name: string;
  createdAt: Date;
  isActive: boolean;
}
export interface Columns {
  title: string;
  key: string;
}

export interface TabSlidePreviewProps {
  selectedFile: UnifiedFile | null; // Thay đổi từ File | string | null
  uploadedFiles: UnifiedFile[]; // Thay đổi từ File[]
  setUploadedFiles: React.Dispatch<React.SetStateAction<UnifiedFile[]>>; // Cập nhật kiểu
  setSelectedFile: React.Dispatch<React.SetStateAction<UnifiedFile | null>>; // Cập nhật kiểu
  pageWidth: number;
  setPageWidth: React.Dispatch<React.SetStateAction<number>>;
  pdfWrapperRef: React.RefObject<HTMLDivElement | null>;
  isEditingFileName: boolean;
  setIsEditingFileName: React.Dispatch<React.SetStateAction<boolean>>;
  handleDownload: () => void;
  handleSaveFileName: () => void;
  handleOnChangeEdit: (type: string, e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  setModalDeleted: React.Dispatch<React.SetStateAction<boolean>>;
  disableSave: boolean;
  isNote: boolean;
  setIsNote: React.Dispatch<React.SetStateAction<boolean>>;
  isEditingNote: boolean; // 👈 thêm
  setIsEditingNote: (val: boolean) => void; // 👈 t
  setActive: React.Dispatch<React.SetStateAction<boolean>>; // Cập nhật kiểu
  handleReset: (type: string) => void;
  setActiveNote: React.Dispatch<React.SetStateAction<boolean>>; // Cập nhật kiểu
  setTempFileName: React.Dispatch<React.SetStateAction<{ name: string; note: string }>>;
}
export interface TabUploadFileDocsProps {
  uploadedFiles: UnifiedFile[]; // Thay đổi từ File[]
  selectedFile: UnifiedFile | null; // Thay đổi từ File | string | null
  onFileSelect: (file: UnifiedFile) => void; // Thay đổi từ (file: File) => void
  showUploadModal: boolean;
  setShowUploadModal: (show: boolean) => void;
  onUploadComplete: (files: File[]) => void;
  onUpload: () => Promise<void>;
}
export interface ActionsConfig {
  edit?: boolean;
  delete?: boolean;
  copy?: boolean;
  download?: boolean;
}
export interface UnifiedFile {
  id: string;
  name: string;
  note?: string;
  type: 'local' | 'remote';
  source: File | string;
  previewUrl?: string;
  attachmentTypeId?: string;
}
// Component props with generic type extending BaseRecord
export interface TableCommonProps<T extends BaseRecord<unknown>> {
  columns: ColumnsType<T> & {
    isDateFilter?: boolean;
  };
  dataSource: T[];
  searchable?: boolean;
  actions?: ActionsConfig;
  onEdit?: (record: T) => void;
  onView?: (record: T) => void;
  onDelete?: (record: T) => void;
  onCopy?: (record: T) => void;
  onDownload?: (record: T) => void;
  onReplace?: (record: T) => void;
  isShowReplace?: (record: T) => boolean;
  displayView?: boolean;
  defaultPageSize?: number;
  pageSizeOptions?: string[];
  tableProps?: Omit<TableProps<T>, 'columns' | 'dataSource' | 'pagination' | 'onChange'>;
  count?: number;
  onPaginationChange: (query: QueryParams) => void;
  handleToggleStatus?: (checked: boolean, record: T) => void;
  currentPage?: number;
  searchColumnDefault?: ParsedFilter[];
  rowSelection?: TableProps<T>['rowSelection'];
  downLoadLoading?: boolean;
  idFileDownload?: string;
}
export interface ToolbarProductProps {
  isActive?: boolean;
  isEdit?: boolean;
  isDetail?: boolean;
  checkInactive?: boolean;
  isLoading: boolean;
  checkUpdate?: boolean;
  version?: number;
  setVersion?: (version: number) => void;
  barcode: string | undefined;
  nameProduct?: string;
  choiceVersion?: (value: string) => void;
  onReplaceVersion?: (replaceVersion: string, versionReplace: number) => void;
  onSaveDraft?: () => void;
  onInactive?: () => void;
  onCancel?: () => void;
  onPublish: () => void;
  setCheckUpdateVersion?: () => void;
  listVersion: ProductVersion[];
  setIsActive: React.Dispatch<React.SetStateAction<boolean>>;
  onActive?: (isActive: boolean) => void;
}
export interface ToolbarForLayoutTwoColProps {
  form: FormInstance;
  isActive?: boolean;
  isEdit?: boolean;
  isDetail?: boolean;
  isLoading: boolean;
  checkUpdate?: boolean;
  createOrderSupplier?: string;
  barcode?: string;
  nameSupplier?: string;
  choiceVersion?: (value: string) => void;
  onSaveDraft?: () => void;
  onCancel?: () => void;
  handleNextStep?: () => void;
  handlePrevStep?: () => void;
  currentStep: number;
  setCheckUpdateVersion?: () => void;
  listVersion: Version[];
  setIsActive: React.Dispatch<React.SetStateAction<boolean>>;
  onActive?: (isActive: boolean) => void;
  isPurchase?: boolean;
  isDisplayCreating?: boolean;
  confirmButton?: boolean;
  confirmButtonLabel?: string;
  onConfirm?: () => void;
  customButton?: React.ReactNode;
  statusLabel?: string;
  statusColor?: string;
}

export type ToastVariant = 'success' | 'error' | 'warning' | 'info';
export interface ToastEventDetail {
  id: string;
  content: string;
  variant: ToastVariant;
  duration: number;
}
export interface ToastOptions {
  content: string;
  variant?: ToastVariant;
  duration?: number;
}
export interface UnitFormValues {
  name: string;
  code?: string;
  unitCategory: string;
  isActive: boolean;
  description?: string;
}
export interface CategoryItem extends BaseRecord<CategoryItem> {
  id: string;
  name: string;
  code: string;
  description?: string;
  isActive?: boolean;
  level?: number;
  parentId?: string | null;
  categoryId?: string | null;
  order?: number;
  brandIds?: string[];
  children?: CategoryItem[];
  createdAt: Date;
}

export interface BrandRecord {
  id: string;
  key: string;
  code: string;
  name: string;
  isActive: boolean;
  status?: string;
  description?: string;
  categories?: CategoryItem[];
  categoryCount?: string;
  createdAt: Date;
  [key: string | number]: string | number | boolean | null | undefined | React.ReactNode | CategoryItem[] | Date;
}

export interface BrandFormValues {
  code: string;
  name: string;
  description?: string;
  isActive: boolean;
  categories?: string[];
  categoryObjects?: CategoryItem[];
}

export const AttributeType = {
  PRODUCT: 'product',
};

export interface AttributeRecord extends BaseRecord<unknown> {
  id?: string;
  code: string;
  name: string;
  isActive: boolean;
  type: string;
  convertValue: number;
  description?: string;
  typeName?: string;
  createdAt: Date;
}

export interface AttributeFormValues {
  code: string;
  name: string;
  type: string;
  convertValue: number;
  isActive: boolean;
  description?: string;
  materials?: (string | number)[][];
}
export interface AddAttributeModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onPublish?: () => void;
  onSubmit: (values: AttributeFormValues) => void;
  onGenerate: () => Promise<string>;
  form: FormInstance<AttributeFormValues>;
  editMode?: boolean;
  attributeData?: AttributeRecord | null;
  isSubmitting?: boolean;
  isCopyMode?: boolean;
}
export interface PaginationProps {
  current: number;
  total: number;
  pageSize: number;
  pageSizeOptions?: string[];
  onChange?: (page: number, pageSize?: number) => void;
  onPageSizeChange?: (current: number, size: number) => void;
  showTotal?: boolean;
  totalTextFormat?: (current: number, pageSize: number, total: number) => string;
  showSizeChanger?: boolean;
  pageSizeText?: string;
  maxVisiblePages?: number;
  className?: string;
}
export const STATUS_TYPE = {
  Product: 'product',
  Supplier: 'supplier',
};

export const UNIT_TYPE = {
  Unit: 'unit',
  Currency: 'currency',
};

export interface SelectOption extends BaseRecord<unknown> {
  value: string | number;
  label: string;
}
export interface CodePayload {
  code: string;
}

export interface ToolbarCustomerProps {
  point?: number;
  type?: string; // ví dụ kiểu
  customerCode: string;
  customerName: string;
  loading?: boolean;
  onSubmit: () => void;
  showDraw?: () => void;
  onCancel: () => void;
}
export const TAG_TYPES = {
  Product: 'Product',
  ProductImage: 'ProductImage',
  Staff: 'Staff',
  Brand: 'Brand',
  Unit: 'Unit',
  Category: 'Category',
  Attribute: 'Attribute',
  Status: 'Status',
  Supplier: 'Supplier',
  OrderSupplier: 'OrderSupplier',
  PurchaseOrder: 'PurchaseOrder',
  Warehouse: 'Warehouse',
  CheckUnique: 'CheckUnique',
  Customer: 'Customer',
  AttachmentType: 'AttachmentType',
  StockOutOrder: 'StockOutOrder',
  Debt: 'Debt',
  Attachment: 'Attachment',
  SaleOrder: 'SaleOrder',
  TransactionMethod: 'TransactionMethod',
  Transaction: 'Transaction',
  CompanyProfile: 'CompanyProfile',
  InventoryCheckOrder: 'InventoryCheckOrder',
  contact: 'contact',
  bank: 'banks',
  bankAccount: 'bankAccount',
  Dashboard: 'Dashboard',
  MemberRank: 'MemberRank',
  ReturnOrder: 'ReturnOrder',
  Material: 'Material',
  importproducts: 'import-products',
  E_INVOICE: 'E_INVOICE',
  Role: 'role',
  Permission: 'permission',
  WarehouseCard: 'WarehouseCard',
  Accounting: 'Accounting',
  // Add more as needed
} as const;
export interface Tag {
  type: (typeof TAG_TYPES)[keyof typeof TAG_TYPES];
  id: string;
}
export interface ResponseFormat<T> {
  data: {
    rows: T[];
    count: number;
  };
  success: boolean;
}
export interface CreateBrandRequest {
  name: string;
  description?: string;
  isActive: boolean;
  categoryIds?: string[];
}

export interface UpdateBrandRequest {
  id: string;
  name?: string;
  description?: string;
  isActive?: boolean;
  categoryIds?: string[];
}
export interface ParentChildMap {
  getChildrenOf: (parentId: string) => string[];
  getParentOf: (childId: string) => string | undefined;
}
export interface CategorySelectionSectionProps {
  form: FormInstance;
  categories: CategoryItem[];
  availableCategories: CategoryItem[];
  setAvailableCategories: (categories: CategoryItem[]) => void;
  selectedCategories: CategoryItem[];
  setSelectedCategories: (categories: CategoryItem[]) => void;
  searchValue: string;
  setSearchValue: (value: string) => void;
  editMode?: boolean;
  isOpen?: boolean;
  checkedAvailableIds: string[];
  setCheckedAvailableIds: (ids: string[]) => void;
}
export interface CreateCategoryRequest {
  id?: string;
  name: string;
  code: string;
  isActive: boolean;
  saleDimensions?: string;
  productDimensions?: { id?: string; name: string; isActive?: boolean }[];
  sizeSpecs?: { id?: string; name: string; isActive?: boolean }[];
  categoryUnits?: ({ id?: string; name?: string; unitId?: string; convertValue?: number } | null)[];
  categoryAttributes?: { id?: string; attributeId: string }[];
}

export interface UpdateCategoryRequest {
  id: string;
  name?: string;
  code?: string;
  description?: string;
  isActive?: boolean;
  level?: number;
  parentId?: string | null;
  brandIds?: string[];
}

export interface ExtendedCategoryItem extends CategoryItem {
  children?: CategoryItem[];
}
export interface CategoryItemProps {
  index: number;
  category: ExtendedCategoryItem;
  level: number;
  expanded: boolean;
  onToggleExpand: (id: string) => void;
  onToggleStatus: (checked: boolean, category: CategoryItem) => void;
  onAddSubCategory: (parentId: string, newCategory?: Partial<CategoryItem>) => void;
  onEdit: (category: CategoryItem) => void;
  onDelete: (category: CategoryItem) => void;
  endList?: boolean;
  onStartAddChild: (parentId: string) => void;
  onFinishAddChild: () => void;
  isCurrentlyAddingChild: boolean;
}
export interface AddBrandModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onSubmit: (values: BrandFormValues) => void;
  onGenerate: () => Promise<string>;
  form: FormInstance;
  isSubmitting?: boolean;
  editMode?: boolean;
  isCopyMode?: boolean;
}

export interface CategoryItemDetail {
  id?: string;
  name: string;
  code: string;
  isActive?: boolean;
  description?: string;
  productDimensions?: Array<{
    id: string;
    name: string;
    isActive?: boolean;
  }>;
  saleDimensions?: string;
  sizeSpecs?: Array<{
    id: string;
    name: string;
    isActive?: boolean;
  }>;
  categoryUnits?: Array<{
    id: string;
    unitId: string;
    convertValue: number;
  }>;
  categoryAttributes?: Array<{
    id: string;
    attributeId: string;
  }>;
}

export interface AddCategoryModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onGenerate: () => Promise<string>;
  onSuccess: () => void;
  form: FormInstance;
  isLoading?: boolean;
  editMode?: boolean;
  isCopyMode?: boolean;
  editingCategory?: CategoryItemDetail | null;
}
export interface ImagePayload {
  id?: string;
  filePath: string;
  name: string;
  order: number;
  url?: string;
}
export interface ImageResponsive {
  id?: string;
  imageId: string;
  order: number;
  productVersionId?: string;
  image: ImagePayload;
}
export interface StatusProduct {
  id: keyof typeof Status;
  name: string;
}
export interface Version {
  id: string;
  version: string;
}

export interface ProductSalePrice {
  minQuantity: number;
  maxQuantity: number;
  note: string;
  salePrice: number;
}
export interface ProductPayload {
  id?: string;
  isPublishing?: boolean;
  isUpdateVersion?: boolean;
  isActive?: boolean;
  code: string;
  barcode?: string;
  name: string;
  categoryId: string;
  statusId?: string | undefined;
  costPrice: number;
  salePrice: number;
  description: string;
  dimension?: string;
  sizeSpec?: string;
  color?: string;
  productId?: string;
  baseUnitId: string;
  currencyUnitId: string;
  minQuantity: number;
  maxQuantity: number;
  brandId?: string;
  productSuppliers?: { supplierId: string }[];
  productAttributes?: Attribute[];
  productUnits?: Unit[];
  imagesInfo?: ImagePayload[];
  productImages?: ImageResponsive[];
  productSalePrices?: ProductSalePrice[];
  product?: Product;
  version?: number;
  density?: number;
  status?: StatusProduct;
  listVersion?: Version[];
  isProductActive?: boolean;
  category?: Category;
  brand?: Brand;
  currencyUnit?: UnitModel;
  baseUnit?: UnitModel;
}

export interface ProductResponse {
  data: ProductPayload;
  success: boolean;
}
export interface ManageProductComponentProps {
  form: FormInstance;
  isLoading: boolean;
  isDetail?: boolean;
  isActive?: boolean;
  defaultIsEdit?: boolean;
  choiceVersion?: (value: string) => void;
  onSubmit: (
    data: {
      productUnits: Unit[];
      productAttributes: Attribute[];
      imagesData: ImagePayload[];
      productSalePrices: ProductSalePrice[];
      productSuppliers?: string[];
    },
    isPublic: boolean,
    publishStatusId?: string,
    isActive?: boolean,
    setModalOpen?: React.Dispatch<React.SetStateAction<boolean>>,
    setStatusSave?: React.Dispatch<React.SetStateAction<string>>,
    isUpdateVersion?: boolean,
    version?: number,
    checkInactive?: boolean,
  ) => void;
  onReplaceVersion?: (replaceVersion: string, versionReplace: number) => void;
  onConfirm: (setInactive?: React.Dispatch<React.SetStateAction<boolean>>) => void;
  onCancel: (setModalOpen?: React.Dispatch<React.SetStateAction<boolean>>) => void;
  onActive?: (
    data: {
      productUnits: Unit[];
      productAttributes: Attribute[];
      imagesData: ImagePayload[];
      productSalePrices?: ProductSalePrice[];
      productSuppliers?: string[];
    },
    isActive: boolean,
  ) => void;
  initialProductUnits?: Unit[];
  initialProductAttributes?: Attribute[];
  initialProductSalePrices?: ProductSalePrice[];
  initialProductSuppliers?: string[];
  initialSupplierId?: string;
}
export interface ModalConfirmProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onCancel: (setModalOpen?: React.Dispatch<React.SetStateAction<boolean>>) => void;
  onConfirm: () => void;
  setInactive?: React.Dispatch<React.SetStateAction<boolean>>;
  isLoading?: boolean;
  checkInactive?: boolean;
  isDetail?: boolean;
  statusSave?: string;
  imageMain?: string;
  form: FormInstance;
  productAttributes?: Attribute[];
  productUnits?: Unit[];
  productSalePrices?: ProductSalePrice[];
  headerLabel?: string;
  headerContent?: string;
  saveButtonLabel?: string;
  brand?: Brand;
  category?: Category;
  suppliers?: Supplier[];
  units?: UnitModel[];
  brandName?: string;
  categoryName?: string;
  currencyUnitName?: string;
  baseUnitName?: string;
  statusToCopy?: string;
}
export interface FileUploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  onUpload?: (files: File[]) => Promise<void>;
  onComplete?: (files: File[], key?: string[]) => void;
  title?: string;
  subtitle?: string;
  acceptedFileTypes?: string;
  fileTypesHelpText?: string;
  multiple?: boolean;
  maxFileSize?: number;
  confirmText?: string;
  positionButton?: 'left' | 'right' | 'center';
  typeModal?: 'upload' | 'import';
  icon?: string;
  disabled?: boolean;
}
export type UploadStatus = 'idle' | 'uploading' | 'done' | 'error';

export type FilterRule =
  | 'eq'
  | 'neq'
  | 'gt'
  | 'gte'
  | 'lt'
  | 'lte'
  | 'like'
  | 'nlike'
  | 'in'
  | 'nin'
  | 'isnull'
  | 'isnotnull';

export interface RawFilterValue {
  rule: FilterRule;
  value?: string | number | (string | number)[];
}

export type FilterInput = Record<string, string | number | boolean | RawFilterValue>;
export interface ExcelOperationsHandlerProps {
  // Entity configuration
  entityType:
    | 'brand'
    | 'unit'
    | 'attribute'
    | 'category'
    | 'supplier'
    | 'product'
    | 'check-order'
    | 'purchase-order'
    | 'sale-order'
    | 'staff'
    | 'member-rank'
    | 'material'
    | 'discount-code'
    | 'brand'
    | 'unit'
    | 'attribute'
    | 'category'
    | 'supplier'
    | 'product'
    | 'check-order'
    | 'purchase-order'
    | 'sale-order'
    | 'return-order'
    | 'warehouse-card';
  entityName: string; // For display in messages ( "Thương hiệu", "Đơn vị", "Thuộc tính", "Danh mục" )

  // Optional filter parameters
  filterParams?: QueryParams;

  // Function to call after operations to refresh data
  onRefresh?: () => Promise<unknown>;

  // UI configuration
  menuPosition?: 'left' | 'right';
  disabled?: boolean;

  // Custom upload modal configuration
  uploadTitle?: string;
  uploadSubtitle?: string;
  acceptedFileTypes?: string;
  fileTypesHelpText?: string;
  multiple?: boolean;
  maxFileSize?: number;
  className?: string;

  // Optional custom handlers if needed
  customHandlers?: {
    onExportTemplate?: () => void;
    onExport?: () => void;
    onExportByView?: () => void;
    onExportByFilter?: () => void;
    onUploadExcel?: (files: File[]) => Promise<void>;
    onUploadComplete?: (files: File[], key?: string[]) => Promise<void>;
  };
}
export interface ExcelDropdownButtonProps extends ExcelSubmenuHandlers {
  className?: string;
  disabled?: boolean;
  position?: 'left' | 'right';
}
export interface ExcelSubmenuHandlers {
  onExportTemplate?: () => void;
  onImport?: () => void;
  onExport?: () => void;
  onExportByView?: () => void;
  onExportByFilter?: () => void;
}
export interface ExcelSubmenuProps {
  isVisible: boolean;
  onClose: () => void;
  handlers: ExcelSubmenuHandlers;
}
export interface AddUnitModalProps {
  isOpen: boolean;
  activeTab: string;
  onCancel: () => void;
  onSubmit: (values: UnitFormValues) => void;
  onGenerate: () => Promise<string>;
  form: FormInstance<UnitFormValues>;
  editMode?: boolean;
  unitData?: UnitRecord | null;
  isSubmitting?: boolean;
  isCopyMode?: boolean;
}
export interface CheckUsedResponse {
  statusCode: number;
  success: boolean;
  data: UsageData[];
}

export interface UsageData {
  table: string;
  ids: string[];
  fields: string[];
}

export interface ReplaceRequest {
  replaceEntityId: string;
  data: UsageData[];
}
export interface DeactivateModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: (replacementRecordId: string) => void;
  activeRecords: BaseRecord<unknown>[];
  recordToDeactivate: BaseRecord<unknown> | null;
  isUpdating?: boolean;
  title?: string;
  entityName?: string;
  onSearch?: (searchTerm: string) => void;
  isSearchLoading?: boolean;
}

export interface ConfirmationModalProps {
  isOpen: boolean;
  onCancel: () => void;
  onConfirm: () => void;
  onSaveDraft?: () => void;
  title: string;
  subtitle: React.ReactNode;
  icon?: 'warning' | 'success' | 'error' | 'info' | 'delete';
  confirmText?: string;
  cancelText?: string;
  confirmLoading?: boolean;
  isPurchase?: boolean;
  createOrderSupplierderSupplier?: string;
}
export interface AlertNotificationProps {
  type?: NotificationType;
  title: string;
  message: string;
  duration?: number;
  onClose?: () => void;
}
export interface BrandInfoSectionProps {
  form: FormInstance;
  onGenerate: () => Promise<string>;
  isActive: boolean;
  setIsActive: (isActive: boolean) => void;
  onSubmit: (values: BrandFormValues) => void;
  editMode?: boolean;
  codePrefix?: string;
  isCopyMode?: boolean;
  setCodePrefix?: (code: string) => void;
}
export interface ReplaceResponse {
  statusCode: number;
  success: boolean;
}
export interface ReplaceResponse {
  statusCode: number;
  success: boolean;
  data: {
    message: string;
  };
}
export interface CategoryCheckboxListProps {
  title: string;
  categories: CategoryItem[];
  allCategories: CategoryItem[];
  checkedIds: string[];
  onSelectAll: (checked: boolean) => void;
  selectionCount?: number;
  totalCount?: number;
  parentChildMap?: {
    getChildrenOf: (parentId: string) => string[];
    getParentOf: (childId: string) => string | undefined;
  };
  selectedCategories?: CategoryItem[];
  className?: string;
  onCheckedIdsChange: (newCheckedIds: string[]) => void;
  pagination: {
    current: number;
    pageSize: number;
    total: number;
  };
  onPageChange: (page: number, pageSize?: number) => void;
  checkboxMode?: 'default' | 'selectedList';
}
// purchase-order
export interface PurchaseOrder extends InventoryDocument {
  type: InventoryDocumentType.PURCHASE_ORDER;
}

export interface PurchaseOrderRecord {
  id: string;
  code: string;
  barcode?: string;
  deliveryDate: string;
  supplierId: string;
  supplierName?: string;
  description?: string;
  note?: string;
  warehouseId: string;
  warehouseName?: string;
  userName: string;
  userPhoneNumber: string;
  userEmail?: string;
  statusId: string;
  status: string | Status;
  paymentType: PaymentType;
  total: number;
  paidMoney: number;
  unpaidMoney: number;
  createdById: string;
  staff?: Staff;
  taxId?: string;
  taxRate?: number;
  items: InventoryDocumentItem[];
  supplier?: Supplier;
  createdAt: Date;
  updatedAt: Date;
}

export interface PurchaseOrderQueryParams {
  page?: number;
  pageSize?: number;
  search?: string;
  supplierId?: string;
  warehouseId?: string;
  status: string | Status;
  dateFrom?: string;
  dateTo?: string;
  sort?: string;
  order?: 'asc' | 'desc';
}

export interface PurchaseOrderFormValues {
  code?: string;
  supplierId: string;
  warehouseId: string;
  deliveryDate: string;
  userName: string;
  userPhoneNumber: string;
  userEmail?: string;
  note?: string;
  description?: string;
  paymentType: PaymentType;
  taxId?: string;
  items: PurchaseOrderItemFormValues[];
}

export interface PurchaseOrderItemFormValues {
  productVersionId: string;
  quantity: number;
  costPrice: number;
}

export interface PurchaseOrderFilter {
  priceRange?: [number, number] | null;
  supplierId?: string;
  warehouseId?: string;
  status?: string | PurchaseOrderStatusCode;
  createdById?: string;
  deliveryDate?: Dayjs;
  hideExpired?: boolean;
  hideCompleted?: boolean;
  codeSearch?: string;
}

export enum PurchaseOrderStatusCode {
  RECEIVED = 'po-received',
  READY = 'po-ready',
  INPROGRESS = 'po-inprogress',
  CANCELLED = 'po-cancelled',
  DELAYED = 'po-delayed',
}
export type StatusForCardStyles = 'READY' | 'RECEIVED' | 'INPROGRESS' | 'CANCELLED' | 'DELAYED';
export const statusLabels: Record<PurchaseOrderStatusCode, string> = {
  [PurchaseOrderStatusCode.READY]: 'Sẵn sàng nhập hàng',
  [PurchaseOrderStatusCode.INPROGRESS]: 'Đang nhập hàng',
  [PurchaseOrderStatusCode.RECEIVED]: 'Đã nhập hàng',
  [PurchaseOrderStatusCode.CANCELLED]: 'Phiếu nhập đã hủy',
  [PurchaseOrderStatusCode.DELAYED]: 'Trễ hạn nhập hàng',
};
export interface DateDisplayProps {
  label: string;
  date: Date | string;
  variant?: 'default' | 'error';
}
export interface PurchaseOrderCardProps {
  code: string;
  createdAt: Date | string;
  deliveryDate: Date | string;
  warehouseName: string;
  supplierName: string;
  status: PurchaseOrderStatusCode;
  isCompact?: boolean;
  delayDays?: number;
  onDetail?: () => void;
  onImport?: () => void;
  onView?: () => void;
}
export interface PurchaseOrderDetailComponentProps {
  paymentDisplay?: boolean;
  staffDisplay?: boolean;
  purchaseOrder: InventoryDocument;
  isModalView?: boolean;
  onClose?: () => void;
  onImport?: () => void;
  onPrint?: () => void;
  onStartImporting?: () => void;
  className?: string;
  paymentStatusType?: PaymentStatusNotiType;
  recivied?: boolean;
  transactions?: Transaction[];
  filesData?: ImagePayload[];
  setFilesData?: React.Dispatch<React.SetStateAction<ImagePayload[]>>;
  onNewFileUpload?: (filePath: string, fileName: string) => Promise<void>;
  onReturn?: () => void;
}
//to mock (will be replaced with productVersion)
export interface ProductData {
  id: string;
  code?: string;
  name: string;
  imageUrl?: string;
  unitPrice: number;
  category: string;
  brand?: string;
  quantity: number;
  actualQuantity?: number;
  unit: string;
  reason?: string | null;
  currencyUnit: string;
  color?: string;
  sizeSpec?: string;
  dimension?: string;
}
export interface ProductItemProps {
  id: string;
  name: string;
  code?: string;
  imageUrl?: string;
  unitPrice: number;
  category?: string;
  brand?: string;
  quantity: number;
  actualQuantity?: number;
  currencyUnit: string;
  unit: string;
  onSelectProduct?: (product: ProductData) => void;
  isSelected?: boolean;
  isQuickView?: boolean;
  isPOS?: boolean;
  dimension?: string | Array<string>;
  attribute?: string;
  atrtributePrice?: number;
  isDisplayTotal?: boolean;
  isDisplaySubtotal?: boolean;
  reason?: string | null;
}
export interface CustomerHistoryComponentProps {
  paymentDisplay?: boolean;
  staffDisplay?: boolean;
  isModalView?: boolean;
  onClose?: () => void;
  className?: string;
  recivied?: boolean;
  Transaction: Transaction;
  profile: Profile;
}

export interface CustomerDetailComponentProps {
  paymentDisplay?: boolean;
  staffDisplay?: boolean;
  isModalView?: boolean;
  onClose?: () => void;
  className?: string;
  recivied?: boolean;
  debt: Debt;
  customer: CustomerCreate;
  profile: Profile;
  transaction: Transaction[];
}

export interface CustomerDetailComponentProps {
  paymentDisplay?: boolean;
  staffDisplay?: boolean;
  isModalView?: boolean;
  onClose?: () => void;
  className?: string;
  recivied?: boolean;
  debt: Debt;
  customer: CustomerCreate;
  profile: Profile;
}

export interface DataTypeSuplierDebt {
  key: string;
  stt: number;
  product: string;
  quantity: number;
  unit: string;
  price: string;
  vat: string;
  total: string;
  extra: string;
  note: string;
}

export interface SupplierDetailComponentProps {
  paymentDisplay?: boolean;
  staffDisplay?: boolean;
  isModalView?: boolean;
  onClose?: () => void;
  className?: string;
  recivied?: boolean;
  debt: Debt;
  Supplier: Supplier;
  setIsDetailModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  profile: Profile;
}
export interface PaymentInfoProps {
  purchaseOrder: InventoryDocument;
  title?: string;
  showPaymentMethods?: boolean;
  showPaymentButton?: boolean;
  showDiscountField?: boolean;
  onPaymentMethodChange?: (method: PaymentType) => void;
  onCustomAmountChange?: (amount: number) => void;
  onDiscountCodeChange?: (code: string) => void;
  onPaymentSubmit?: () => void;
  onImport?: () => void;
  vatRate?: number;
  disableEditing?: boolean;
  differentItems?: InventoryDocumentItem[];
  debt?: Debt;
  recivied?: boolean;
  setPaymentMethod?: React.Dispatch<React.SetStateAction<PaymentType>>;
  paymentMethod?: PaymentType;
  customAmount?: string;
  setCustomAmount?: React.Dispatch<React.SetStateAction<string>>;
  datePayment?: Dayjs;
  setDatePayment?: React.Dispatch<React.SetStateAction<Dayjs | undefined>>;
  onUpload?: (files: File[]) => Promise<void>;
  onContinue?: () => void;
  transactions?: Transaction[];
  transactionMethod?: TransactionMethodCode;
  setTransactionMethod?: React.Dispatch<React.SetStateAction<TransactionMethodCode>>;
}
export interface PaymentDebtProp {
  title?: string;
  showPaymentMethods?: boolean;
  showPaymentButton?: boolean;
  showDiscountField?: boolean;
  onPaymentMethodChange?: (method: PaymentType) => void;
  onCustomAmountChange?: (amount: number) => void;
  onDiscountCodeChange?: (code: string) => void;
  onPaymentSubmit?: () => void;
  vatRate?: number;
  disableEditing?: boolean;
  differentItems?: InventoryDocumentItem[];
  debt?: Debt;
  recivied?: boolean;
  setPaymentMethod?: React.Dispatch<React.SetStateAction<PaymentType>>;
  paymentMethod?: PaymentType;
  customAmount?: string;
  setCustomAmount?: React.Dispatch<React.SetStateAction<string>>;
  datePayment?: Dayjs;
  setDatePayment?: React.Dispatch<React.SetStateAction<Dayjs | undefined>>;
  onUpload?: (files: File[]) => Promise<void>;
  onContinue?: () => void;
  transactions?: Transaction[];
  transactionMethod?: TransactionMethodCode;
  setTransactionMethod?: React.Dispatch<React.SetStateAction<TransactionMethodCode>>;
  idRefId?: string;
}
export interface PaymentDebtProp {
  title?: string;
  showPaymentMethods?: boolean;
  showPaymentButton?: boolean;
  showDiscountField?: boolean;
  onPaymentMethodChange?: (method: PaymentType) => void;
  onCustomAmountChange?: (amount: number) => void;
  onDiscountCodeChange?: (code: string) => void;
  onPaymentSubmit?: () => void;
  vatRate?: number;
  disableEditing?: boolean;
  differentItems?: InventoryDocumentItem[];
  debt?: Debt;
  recivied?: boolean;
  setPaymentMethod?: React.Dispatch<React.SetStateAction<PaymentType>>;
  paymentMethod?: PaymentType;
  customAmount?: string;
  setCustomAmount?: React.Dispatch<React.SetStateAction<string>>;
  datePayment?: Dayjs;
  setDatePayment?: React.Dispatch<React.SetStateAction<Dayjs | undefined>>;
  onUpload?: (files: File[]) => Promise<void>;
  onContinue?: () => void;
  transactions?: Transaction[];
  transactionMethod?: TransactionMethodCode;
  setTransactionMethod?: React.Dispatch<React.SetStateAction<TransactionMethodCode>>;
}
export interface ActionButtonsProps {
  onPrint?: () => void;
  onImportPartial?: () => void;
  onStartImporting?: () => void;
  onImport?: () => void;
  status?: string;
  canBeImported: boolean;
  isImporting: boolean;
  isImported: boolean;
  isDelayed?: boolean;
}

export interface Step {
  title: string;
  icon: React.ReactNode;
}
export interface StepToStepCommonProps {
  current: number;
  steps: Step[];
}
export interface Step {
  title: string;
  icon: React.ReactNode;
  isCompleted?: boolean;
}

export interface StepToStepCommonProps {
  current: number;
  className?: string;
  steps: Step[];
}

export interface UseQuantityProps {
  initialValue?: number;
  min?: number;
  max?: number;
}

export interface UseQuantityReturn {
  quantity: number;
  increment: () => void;
  decrement: () => void;
  setQuantity: (value: number) => void;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  isAtMin: boolean;
  isAtMax: boolean;
}

export interface ProductCardProps {
  product: Product;
  onAddToCart?: (id: string, quantity: number, setIsOnCart?: (isOnCart: boolean) => void) => void;
  onDeleteCart?: (id: string) => void;
  itemQuantity?: number;
}

export interface SupplierContact {
  phone?: string;
  email?: string;
  qrCodeUrl?: string;
}

export interface ConfirmPaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  fileName?: string;
  supplierContact?: SupplierContact;
  onBack?: () => void;
  onContinue?: () => void;
  onUpload?: (files: File[]) => Promise<void>;
  customActions?: React.ReactNode;
  contentStep3?: React.ReactNode;
  type?: 'trả' | 'nhập' | 'đặt';
}
export type PaymentStatusNotiType = 'pending' | 'waiting' | 'success' | 'error' | 'warning';

export interface PaymentStatusNotiProps {
  type?: PaymentStatusNotiType;
  title: string;
  subtitle: string;
  highlightedText?: string;
  icon?: ReactNode;
  className?: string;
  bgColor?: string;
}

export interface QRCodeModalProps {
  isOpen: boolean;
  onClose: () => void;
  qrCodeUrl: string;
  companyName: string;
  onMessageViaZalo?: () => void;
  phoneNumber?: string;
}
export interface LayoutTwoColComponentProps {
  currentStep?: number;
  steps?: Step[];
  left: React.ReactNode;
  right: React.ReactNode;
  onNextStep?: () => void;
  onPrevStep?: () => void;
  onCancel?: () => void;
  onSaveDraft?: () => void;
  form: FormInstance;
  isPurchase?: boolean;
  createOrderSupplier?: string;
  isLoading?: boolean;
  showStep?: boolean;
  showToolbar?: boolean;
  classname?: string;
  rightClassName?: string;
  leftClassName?: string;
  isDisplayCreating?: boolean;
  confirmButton?: boolean;
  confirmButtonLabel?: string;
  onConfirm?: () => void;
  navigateLink?: string;
  customButton?: React.ReactNode;
  cancelButton?: boolean;
  statusLabel?: string;
  statusColor?: string;
  stickyTop?: number;
}
export interface SupplierRecord extends BaseRecord<unknown> {
  key: string;
  id: string;
  'baseUser.code': string;
  'baseUser.name': string;
  group: string;
  'baseUser.isActive': boolean;
  productCount: number;
  taxCode: string;
  'baseUser.address': string;
}
export interface CheckOrderRecord extends BaseRecord<unknown> {
  id: string;
  key: string;
  code: string;
  'createdBy.baseUser.name': string;
  createdAt: Date | string;
  difference: number;
  description?: string;
  'status.code': CheckOrderStatusCode;
  inventoryDocumentItems?: InventoryDocumentItem[];
}

export interface CustomerRecord extends BaseRecord<unknown> {
  key: string;
  id: string;
  ['baseUser.code']: string;
  ['baseUser.name']: string;
  ['baseUser.email']: string;
  statusCode: string;
  ['baseUser.phoneNumber']: string;
  description?: string;
}

export interface CustomerFillter {
  debttype?: string;
  time?: string;
  codeSearch?: string;
  transactiontype?: string;
  status?: string;
  localRange?: number;
  id?: string;
  transactionMethodId?: string;
}

export interface CustomerInfoSectionProps {
  form: FormInstance;
  id?: string;
  typeComponent?: string;
  setCustomerCode: React.Dispatch<React.SetStateAction<string>>;
  setCustomerName: React.Dispatch<React.SetStateAction<string>>;
}

export interface CustomerTabNavigationProps {
  tabButtonClass: {
    base: string;
    active: string;
    inactive: string;
  };
  tabSpanClass: {
    base: string;
    active: string;
    inactive: string;
  };
  activeKey: string;
  idCustomer?: string;
}
export interface FilterCustomerProps {
  initialFilter?: CustomerFillter;
  onApplyFilter: (filter: CustomerFillter) => void;
  onClearFilter: () => void;
  stateDraw?: boolean;
  onCloseDraw?: () => void;
  listStatus?: StatusType[];
  type?: string;
  id?: string;
  priceRange: [number, number];
  setPriceRange: (range: [number, number]) => void;
}

export interface FilterHistoryCustomerProps {
  initialFilter?: CustomerFillter;
  onApplyFilter: (filter: CustomerFillter) => void;
  onClearFilter: () => void;
  stateDraw?: boolean;
  onCloseDraw?: () => void;
  listStatus?: TransactionMethod[];
  id?: string;
  priceRange: [number, number];
  setPriceRange: (range: [number, number]) => void;
}

export enum CheckOrderStatusCode {
  CHECKED = 'invcheck-completed',
  CHECKING = 'invcheck-inprogress',
  WAITING = 'invcheck-pending',
}
export const checkOrderStatusLabels: Record<CheckOrderStatusCode, string> = {
  [CheckOrderStatusCode.CHECKED]: 'Đã kiểm kho',
  [CheckOrderStatusCode.CHECKING]: 'Đang kiểm kho',
  [CheckOrderStatusCode.WAITING]: 'Đợi kiểm kho',
};
export interface SupplierOrderListProps {
  form: FormInstance;
  selectedSupplierId: string | number | undefined;
  setSelectedSupplierId: React.Dispatch<React.SetStateAction<string | number | undefined>>;
  cartProducts?: ProductVersion[];
  setCartProducts?: React.Dispatch<React.SetStateAction<ProductVersion[]>>;
  className?: string;
  initItems?: Record<string, number>;
}
export interface SupplierOrderInforProps {
  form: FormInstance;
  handleCreatecode: () => void;
  handleBarcode: () => void;
  selectedSupplierId: string | number | undefined;
  setSelectedSupplierId?: React.Dispatch<React.SetStateAction<string | number | undefined>>;
  isPurchase?: boolean;
}

export interface SupplierOrderCartProps {
  products: Product[];
  totalQuantity: number;
  totalPrice: number;
  vat?: number;
  setVat?: React.Dispatch<React.SetStateAction<number>>;
  initQuantity?: number;
  handleCheckAll?: (e: CheckboxChangeEvent) => void;
}
export interface SupplierFiltersProps {
  form: FormInstance;
  selectedSupplierId?: string | number;
  setSelectedSupplierId: React.Dispatch<React.SetStateAction<string | number | undefined>>;
  debouncedSetSearchName: React.Dispatch<React.SetStateAction<string>>;
  setSearchCategory: React.Dispatch<React.SetStateAction<string>>;
  setPriceRange: React.Dispatch<React.SetStateAction<number[]>>;
  priceRange: number[];
  setSortValue: React.Dispatch<React.SetStateAction<string>>;
  className?: string;
}
export interface SupllierPaymentConfirmProps {
  form: FormInstance;
  handleCreatecode: () => void;
  handleBarcode: () => void;
  selectedSupplierId: string | number | undefined;
}
export interface ModalConfirmPaymentProps {
  open: boolean;
  onClose: () => void;
  saveButtonLabel?: string;
  headerLabel?: string;
  headerContent?: string;
  onSubmit?: () => void;
  form: FormInstance;
  isLoading?: boolean;
  handleUploadExcel?: (files: File[]) => Promise<void>;
}
export interface ChoicePaymentProps {
  form: FormInstance;
  subTotal: number;
  totalQuantity: number;
  cartList: Product[];
  defaultMethod?: PaymentType;
  labelHeader?: string;
  backgroundHeader?: 'white' | 'transparent';
  classname?: string;
  defaultCouple?: string;
  defaultVat?: number;
  defaultCustomAmount?: number;
  customAmount: number;
  setCustomAmount?: React.Dispatch<React.SetStateAction<number>>;
  onSubmit?: (
    subTotal: number,
    transactionMethod: TransactionMethodCode,
    selectedMethod: PaymentType,
    currentStep: number,
  ) => void;
  onConfirmPayment?: () => void;
  isRead?: boolean;
  selectedMethod: PaymentType;
  setSelectedMethod: React.Dispatch<React.SetStateAction<PaymentType>>;
  isLoading?: boolean;
  statusDefault?: StatusOrderSupplierCode;
  setSelectedVAT?: React.Dispatch<React.SetStateAction<number>>;
  selectedVAT?: number;
  handleUploadExcel?: (files: File[]) => Promise<void>;
}
export interface CommonSliderProps {
  title?: string;
  value?: number[];
  onChange: (value: number[]) => void;
  min?: number;
  max?: number;
  disabled?: boolean;
  width?: string;
}
export interface UseAddCategoryOperationsProps {
  editMode?: boolean;
  editingCategory?: CategoryItemDetail | null;
  onGenerate?: () => Promise<string>;
  onSuccess?: () => void;
  isOpen?: boolean;
  isCopyMode?: boolean;
  setExternalRowValues: React.Dispatch<React.SetStateAction<Record<number, string[]>>>;
  setExternalConfirmedRows: React.Dispatch<React.SetStateAction<number[]>>;
  formInstance?: FormInstance;
}

export interface CategoryFilter {
  attributeSearch?: string;
}
export enum TableEnum {
  Materials = 'Materials',
  Categories = 'Categories',
  Brands = 'Brands',
  Products = 'Products',
  Attributes = 'Attributes',
  Units = 'Units',
  TransactionMethods = 'TransactionMethods',
  InventoryDocuments = 'InventoryDocuments',
  SaleOrders = 'SaleOrders',
  Suppliers = 'Suppliers',
  BaseUsers = 'BaseUsers',
  Customer = 'Customers',
}
export interface CheckUniqueRequest {
  table: TableEnum;
  field: string;
  value: string;
}
export interface CheckUniqueResponse {
  success: boolean;
  statusCode: number;
  data: {
    message: string;
    exists: boolean;
  };
}

export interface CategoryFormSectionsProps {
  activeForm: FormInstance;
  codePrefix: string;
  setCodePrefix: (value: string) => void;
  onGenerate?: () => Promise<string>;
  editMode: boolean;
  isCopyMode: boolean;
  rowValues: Record<number, string[]>;
  confirmedRows: number[];
  handleInputChange: (rowIndex: number, colIndex: number, value: string) => void;
  confirmRow: (rowIndex: number) => boolean;
  unconfirmRow: (rowIndex: number) => void;
  removeRow: (rowIndex: number) => void;
  addNewRow: () => void;
  selectedValues: string[];
  isAttributesLoading: boolean;
  isActive: boolean;
  attributeOptions: {
    label: string;
    value: string;
    type: string;
    id: string;
  }[];
  shouldLoadAttributes: boolean;
  setShouldLoadAttributes: (value: boolean) => void;
  setSelectedValues: (values: string[]) => void;
  handleAttributeSearch: (value: string) => void;
  handleToggleActive: (checked: boolean) => void;
  handleSubmit: (values: CategoryFormValues) => Promise<void>;
}
export interface UseEntitySearchProps<T, R> {
  searchFunction: (params: { query: QueryParams }) => Promise<T>;
  formatResults: (data: T) => R[];
  filterResults?: (item: R, currentId?: string) => boolean;
  debounceTime?: number;
  defaultFilter?: string;
  defaultSort?: string;
  pageSize?: number;
  defaultInclude?: string;
  defaultFieldSearch?: string;
}

export interface UseEntitySearchReturn<R> {
  searchResults: R[];
  isSearching: boolean;
  searchTerm: string;
  handleSearch: (term: string, entityId?: string) => void;
  resetSearch: () => void;
}
export type UnitItem = {
  id: string;
  checked: boolean;
  quantity: number;
  label: string;
  isNew?: boolean;
};
export interface DebtPaymentInfoProps {
  debt: Debt;
  debtId: string;
  paymentMethod: PaymentType;
  setPaymentMethod: (method: PaymentType) => void;
  scheduleDate: Dayjs | null;
  setScheduleDate: (date: Dayjs | null) => void;
  title?: string;
  showPaymentMethods?: boolean;
  showPaymentButton?: boolean;
  vatRate?: number;
  disableEditing?: boolean;
  paymentAmount?: number | null;
  setPaymentAmount?: (amount: number | null) => void;
  saleOrderItems: SaleOrderItem[];
  inventoryDocumentItems: InventoryDocumentItem[];
  transactions: Transaction[];
}
export interface FileData {
  id?: string;
  filePath: string;
  order: number;
  name: string;
}

export interface TitleModelSuplierProps {
  title?: string;
  subtitle?: string;
}

export interface ContactSupplier {
  id?: string;
  name: string;
  jobTitle: string;
  phoneNumber: string;
  email: string;
  description: string;
  isDefault: boolean;
  SupplierId?: string;
}
export interface BankAccount {
  id?: string;
  bankId: string;
  supplierId: string;
  accountOwner: string;
  accountNumber: string;
  cardNumber?: string;
  cvv?: string;
  qrCode?: string;
  isDefault?: boolean;
  bank?: Bank;
  bankBranch: string;
}

export interface TabContactSupplierProps {
  contactList: ContactSupplier[];
  setContactList: React.Dispatch<React.SetStateAction<ContactSupplier[]>>;
}

export interface TabBankSupplierProps {
  inforBank: BankAccount[];
  setInforBamk: React.Dispatch<React.SetStateAction<BankAccount[]>>;
}

export interface FormCreateSupplierProps extends TabBankSupplierProps {
  form: FormInstance<SupplierFormValues>;
  id?: string;
  data: Supplier;
  setSupplierCode: (value: string) => void;
  setSupplierName: (value: string) => void;
  contact: TabContactSupplierProps;
}

export interface TabAddContactPeoplePageProps {
  setClose: () => void;
  contact: TabContactSupplierProps;
  idEdit?: string;
}

export interface Bank {
  id: string;
  code: string;
  name: string;
  logo: string;
  createdAt: string; // ISO date string
  updatedAt: string; // ISO date string
  deletedAt: string | null;
}

export interface InformationPaymentProps {
  setClose: React.Dispatch<React.SetStateAction<boolean>>;
  handleBank: TabBankSupplierProps;
  id?: string;
}
export interface ParsedFilter {
  key: string;
  operator?: string;
  raw: string;
}
